"use client";

import { cn } from "@repo/ui";
import { type MotionProps, motion, useScroll } from "motion/react";
import type * as React from "react";
import type { RefObject } from "react";

export interface ScrollProgressProps
	extends Omit<React.HTMLAttributes<HTMLElement>, keyof MotionProps> {
	ref?: React.Ref<HTMLDivElement>;
	/**
	 * Scroll container to track. Defaults to the document viewport
	 * (marketing / site chrome). Pass a ref for in-app overflow panes
	 * (e.g. topic docs learner).
	 */
	containerRef?: RefObject<HTMLElement | null>;
}

export function ScrollProgress({
	className,
	ref,
	containerRef,
	...props
}: ScrollProgressProps) {
	const { scrollYProgress } = useScroll(
		containerRef != null ? { container: containerRef } : undefined,
	);

	return (
		<motion.div
			ref={ref}
			className={cn(
				// Below marketing topic/completion overlays and sheets; under sticky header (`MARKETING_SITE_HEADER_STACK_Z_CLASS`).
				"fixed inset-x-0 top-[var(--marketing-site-header-height,7rem)] z-[150] h-1 origin-left bg-gradient-to-r from-[#A97CF8] via-[#F38CB8] to-[#FDCC92]",
				className,
			)}
			style={{
				scaleX: scrollYProgress,
			}}
			{...props}
		/>
	);
}
